import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { ThemeProvider } from "next-themes";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/SmoothScroll";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import { scrollToId } from "@/components/Reveal";
import HomePage from "@/pages/HomePage";
import CaseStudyPage from "@/pages/CaseStudyPage";

const HashScroll = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.pathname === "/" && location.hash) {
      const id = location.hash.replace("#", "");
      setTimeout(() => scrollToId(id), 300);
    }
  }, [location]);
  return null;
};

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false} disableTransitionOnChange>
      <div className="App">
        <BrowserRouter basename={process.env.PUBLIC_URL}>
          <SmoothScroll>
            <Toaster position="top-center" richColors />
            <Nav />
            <HashScroll />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/case-study/:slug" element={<CaseStudyPage />} />
            </Routes>
            <Footer />
          </SmoothScroll>
        </BrowserRouter>
      </div>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
